export function wordCount(text: string) {
  // Remove leading and trailing whitespaces
  if (text === undefined) {
    return 0;
  }
  const trimmedText = text.trim();

  // If the text is empty, return 0
  if (!trimmedText) {
    return 0;
  }

  // Split the text into an array of words using spaces as separators
  const wordsArray = trimmedText.split(/\s+/);

  // Count the number of words in the array
  const wordCount = wordsArray.length;

  return wordCount;
}
